document.addEventListener("DOMContentLoaded", () => {

  const waveformContainer =
    document.querySelector("#sounfree-waveform");

  if (!waveformContainer) return;

  const trackButtons =
    document.querySelectorAll(".sounfree-player__track");

  const playButton =
    document.querySelector(".sounfree-player__play");

  if (!trackButtons.length) return;

  /* =========================
     WAVESURFER
  ========================= */

const wavesurfer = WaveSurfer.create({

  container: "#sounfree-waveform",

  waveColor: "rgba(255,255,255,.82)",

  progressColor: "#ff2d2d",

  cursorColor: "transparent",

  barWidth: 1.2,

  barGap: 3.2,

  barRadius: 999,

  height: 58,

  normalize: false,

  dragToSeek: true,

  autoCenter: true

});

  let currentTrack =
    trackButtons[0];

  let isPlaying = false;

  /* =========================
     LOAD TRACK
  ========================= */

  function loadTrack(button) {

    const audioUrl =
      button.dataset.audio;

    if (!audioUrl) return;

    trackButtons.forEach((track) => {
      track.classList.remove("is-active");
    });

    button.classList.add("is-active");

    currentTrack = button;

    wavesurfer.load(audioUrl);

  }

  /* =========================
     PLAY / PAUSE
  ========================= */

  function togglePlayback() {

    wavesurfer.playPause();

  }

  playButton.addEventListener("click", () => {

    togglePlayback();

  });

  /* =========================
     TRACK SWITCH
  ========================= */

  trackButtons.forEach((button) => {

    button.addEventListener("click", () => {

      const sameTrack =
        currentTrack === button;

      if (!sameTrack) {

        loadTrack(button);

        wavesurfer.once("ready", () => {

          wavesurfer.play();

        });

      } else {

        togglePlayback();

      }

    });

  });

  /* =========================
     PLAYER STATES
  ========================= */

  wavesurfer.on("play", () => {

    isPlaying = true;

    playButton.textContent = "PAUSE";

  });

  wavesurfer.on("pause", () => {

    isPlaying = false;

    playButton.textContent = "PLAY";

  });

  wavesurfer.on("finish", () => {

    isPlaying = false;

    playButton.textContent = "PLAY";

  });

  /* =========================
     INITIAL TRACK
  ========================= */

  loadTrack(currentTrack);

});